// extracted by mini-css-extract-plugin
module.exports = {"tooltipContent":"TooltipRelative_tooltipContent__WYzT9","tooltipArrow":"TooltipRelative_tooltipArrow__JG8bH"};